import AppFormSelect from '../../../../../../components/ui/AppFormSelect';
import AppFormInput from '../../../../../../components/ui/AppFormInput';
import apiClient from "../../../../../../services/api-client";
import React, { useState } from "react";
 
import { BlockUI } from 'primereact/blockui'; 
import { useMountEffect } from 'primereact/hooks';

import StorageHelper from '../../../../../../utils/storage-helper';
import AppCard from "../../../../../../components/ui/AppCard";

const BankingDetailsForm = ({ moveToNextView, moveToPreviousView, userPolicyInput, setuserPolicyInput, titles, toast }) => {
  const [bankName, setBankName] = useState("");
  const [bankId, setBankId] = useState(0);
  const [branchCode] = useState("");
  const [accountNumber, setAccountNumber] = useState("");
  const [branchName, setBranchName] = useState("");
  const [branches, setBranchOptions] = useState([])
  const [accountName, setAccountName] = useState("");
  const [accountType, setAccountType] = useState("");
  const accountTypes = [
    {name: "Savings", value: "savings"},
    {name: "Current", value: 'current'},
    {name: "Fixed Deposit", value: 'fixed deposit'}, 
    {name: "Joint", value: 'joint'}, 
    {name: "Business", value: 'business'}]; // Add more as needed
  const [loading, setloading] = useState(false);



  const moveToNext = (e) => {
    e.preventDefault();

    // Validation logic here
    // if ( bankName.trim() === "" || accountNumber.trim() === "" || branchName.trim() === "" || accountType.trim() === ""
    // ) {
    //   return;
    // }

    const bankDetail = [{
      "BankName": bankName.BankName1,
      "BankNameId": bankId.BankID,
      "BranchName": branchName,
      "Account_Name": accountName,
      "Account_Number": accountNumber,
      "Type_of_Account": accountType.toLowerCase(),
      "Branch_Code": branchCode,
      "MemberID": 0,
      "StartDate": "2023-08-03T16:28:51.868Z",
      "cardExpiryDate": "2023-08-03T16:28:51.868Z",
      "tokenExpiryDate": "2023-08-03T16:28:51.868Z"
    }];
    const payload = {
      "operation": "createPolicyApplicationStage3",
      "requestBody": {
        "planId": userPolicyInput.selectedPlanName,
        "planName": userPolicyInput.selectedPlanID,
        "productId": userPolicyInput.selectedProductId,
        "productName": userPolicyInput.selectedProductName,
        "applicationTotalStages": 3,
        "currentStages": 2,
        "applicationType": userPolicyInput.selectedPlanType,
        "mainMember": userPolicyInput.mainMember,
        "memberSpouse": userPolicyInput.memberSpouse,
        "memberChild": userPolicyInput.memberChild,
        "memberExtended": userPolicyInput.memberExtended,
        "memberBeneficiary": userPolicyInput.memberBeneficiary,
        "bankDetail":bankDetail
      }
    }
    setuserPolicyInput({ ...userPolicyInput, bankDetail: bankDetail });
    submitStage3toServer(payload);
  };

  const fetchFromUser = ()=>{
    const userProfileData = StorageHelper.get("userProfile");

    if (userProfileData) {
        try {
            const decodedData = typeof userProfileData === 'string' ? JSON.parse(userProfileData) : userProfileData;
            setAccountName(decodedData.firstName+" "+decodedData.lastName)

        } catch (error) {
            console.error("Error parsing JSON:", error);
        }
    } else {
        //console.log("userProfileData not found in localStorage.");
    }

  }

  function populateForExisting() {

    //console.log(userPolicyInput.bankDetail)
    if(userPolicyInput.bankDetail && userPolicyInput.bankDetail.length > 0){
      setBankName(userPolicyInput.bankDetail[0].BankNameId)
      setBankId(userPolicyInput.bankDetail[0].BankNameId)
      setAccountNumber(userPolicyInput.bankDetail[0].Account_Number)
      setBranchName(userPolicyInput.bankDetail[0].Branch_Code)
      setAccountName(userPolicyInput.bankDetail[0].Account_Name)
      setAccountType(userPolicyInput.bankDetail[0].Type_of_Account)
  
      // nationalityOptions
    }
  }

  useMountEffect(() => {
    //console.log(userPolicyInput)
    fetchFromUser()
    fetchBanks();
    populateForExisting()

});

  async function fetchBanks() {
    setloading(true);
    await apiClient.get('policy/banks', {
      headers: {
        Authorization: 'Bearer ' + StorageHelper.get('token'),
        'Content-Type': 'application/json'
      }
    }).then((response) => {
      setloading(false);
      setBranchOptions(response.data.responseBody)
    }).catch((error) => {
      setloading(false);
      console.error('Error fetching banks:', error);
    })
  }


  const showToastMessage = (title, message, messageType) => {
    toast.current.show({ severity: messageType, summary: title, detail: message, life: 15000 });
  }

  const submitStage3toServer = async (payload) => {
    setloading(true);
    //console.log(payload);
    await apiClient.post('policy/apply/2', payload,{
      headers: {
        Authorization: 'Bearer ' + (StorageHelper.get('token'))
      }
    }).then((response) => {

      if (response.data.status === "SUCCESS") {
        setloading(false);
        //console.log(response.data.responseBody)
        showToastMessage("Progress Saved", userPolicyInput.mainMemberName + " your progress has been saved", "success");
        moveToNextView();
      }
      else {
        setloading(false);
        showToastMessage("Failed to save your progress", response.data.message, "warn");
      }
    }).catch((e) => {
      setloading(false);
      //console.log(e)
      // showException()
    })


  }

  return (
    <div className="w-full max-w-5xl mx-auto mb-12">
      <BlockUI blocked={loading}>
        <AppCard>
          <div className="bg-base-200/50 px-8 py-6 border-b border-base-200">
            <h3 className="text-2xl font-bold text-base-content mb-1">Fill in Banking details</h3>
            <p className="text-base-content/70 text-sm">Please provide your banking details for policy payments.</p>
          </div>

          <form onSubmit={moveToNext} className="p-8">

            <div className="grid grid-cols-1 md:grid-cols-2 gap-x-6 gap-y-2">

              <AppFormSelect
                  containerClassName="col-span-1 mb-4"
                  id="bankName"
                  label="Bank Name"
                  value={bankName}
                  options={branches}
                  optionLabel="BankName1"
                  placeholder="Select your Bank"
                  onChange={(e) => {
                    setBankName(e.target.value);
                    setBankId(e.target.value);
                  }}
              />

              <AppFormInput
                  containerClassName="col-span-1 mb-4"
                  label="Branch Name"
                  type="text"
                  id="branchName"
                  placeholder="Enter branch name"
                  name="branchName"
                  value={branchName}
                  onChange={(e) => setBranchName(e.target.value)}
              />

              <AppFormSelect
                  containerClassName="col-span-1 mb-4"
                  id="accountType"
                  label="Account Type"
                  value={accountType}
                  options={accountTypes}
                  optionLabel="name"
                  placeholder="Select Account Type"
                  onChange={(e) => setAccountType(e.target.value)}
              />

              <AppFormInput
                  containerClassName="col-span-1 mb-4"
                  label="Account Name"
                  type="text"
                  id="accountName"
                  placeholder="Enter account name"
                  name="accountName"
                  value={accountName}
                  onChange={(e) => setAccountName(e.target.value)}
              />

              <AppFormInput
                  containerClassName="col-span-1 md:col-span-2 mb-4"
                  label="Account Number"
                  id="accountNumber"
                  placeholder="Enter account number"
                  name="accountNumber"
                  value={accountNumber}
                  onChange={(e) => setAccountNumber(e.target.value)}
              />

            </div>

            <div className="card-actions justify-end mt-8 pt-6 border-t border-base-200/50">
              <button
                  type="submit"
                  className="btn btn-primary rounded-full px-12 shadow-md hover:shadow-lg transition-all font-bold tracking-wide text-white"
              >
                Continue <i className="pi pi-arrow-right ml-2 text-sm"></i>
              </button>
            </div>
          </form>
        </AppCard>
      </BlockUI>
    </div>
  );
};

export default BankingDetailsForm;